import React, { useState, useEffect } from "react";
import { getPracticeTestReport_API,getDropdownFilters_API } from "../../api/endpoints";
import CustomPagination from "../../api/custompagination";
import ExcelJS from "exceljs";
const PracticeTestReport = ({userRole,institute,collegeName}) => {
 console.log("userrole,institute,collegeName",userRole,institute,collegeName)
    const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [collegeId, setCollegeId] = useState("");
  const [department, setDepartment] = useState("");
  const [year, setYear] = useState("");
  const [collegeOptions, setCollegeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
   useEffect(() => {
    if (userRole === "Placement Officer") {
      setCollegeId(institute);
    }
  }, [userRole, institute]);

  // Fetch all filter options ONCE on mount
useEffect(() => {
  const fetchAllFilters = async () => {
    try {
      const res = await getDropdownFilters_API(); // no college_id param
      if (res) {
        setCollegeOptions(res.colleges || []); // ALL colleges
        setDepartmentOptions(res.departments || []); // ALL departments
        setYearOptions(res.years || []); // ALL years
      }
    } catch (err) {
      console.error("Error fetching dropdown filters:", err);
    }
  };

  fetchAllFilters();
}, []);

// Fetch table data whenever filters change
useEffect(() => {
  fetchReportData();
}, [currentPage, searchTerm, collegeId, department, year]);

// Optional: If you want department/year dropdowns to only show relevant options based on selected college
// fetch department/year dynamically but DO NOT overwrite collegeOptions
useEffect(() => {
  const fetchDepartmentYearForCollege = async () => {
    if (!collegeId) return;

    try {
      const res = await getDropdownFilters_API({ college_id: collegeId });
      if (res) {
        setDepartmentOptions(res.departments || []);
        setYearOptions(res.years || []);
      }
    } catch (err) {
      console.error("Error fetching department/year filters:", err);
    }
  };

  fetchDepartmentYearForCollege();
}, [collegeId]);

 const fetchReportData = async () => {
  try {
    setLoading(true);

    const response = await getPracticeTestReport_API({
      page: currentPage,
      search: searchTerm,
 college_id: userRole === "Placement Officer" ? institute : collegeId, // Always pass institute for PO
 
      //college_id: collegeId,
      department: department,
      year: year,
    });

    if (response?.results) {
      setData(response.results);
      setTotalPages(Math.ceil(response.count / 10));
    } else {
      setData([]);
      setTotalPages(1);
    }
  } catch (error) {
    console.error("❌ Error fetching practice test report:", error);
  } finally {
    setLoading(false);
  }
};

// Runs once on mount — gets ALL dropdown data
const fetchFilterOptions = async () => {
    let page = 1;
    let hasMore = true;
    const colleges = new Set();
    const departments = new Set();
    const years = new Set();

    while (hasMore) {
      const res = await getPracticeTestReport_API({ page });
      if (res?.results) {
        res.results.forEach((item) => {
          if (item.collegeId && item.college_id) {
            colleges.add(JSON.stringify({ id: item.collegeId, name: item.college_id }));
          }
          if (item.department_id) {
            departments.add(item.department_id);
          }
          if (item.year) {
            years.add(item.year);
          }
        });
        hasMore = !!res.next;
        page++;
      } else {
        hasMore = false;
      }
    }

    setCollegeOptions(Array.from(colleges).map((c) => JSON.parse(c)));
    setDepartmentOptions(Array.from(departments));
    setYearOptions(Array.from(years).sort());
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchReportData();
  }, [currentPage, searchTerm, collegeId, department, year]);

const exportToExcel = async () => {
    try {
      let page = 1;
      let allData = [];
      let hasMore = true;

      while (hasMore) {
        const res = await getPracticeTestReport_API({
          page,
          search: searchTerm,
          college_id: userRole === "Placement Officer" ? institute : collegeId, // Always pass institute for PO
          department,
          year
        });

        if (res?.results?.length) {
          allData = [...allData, ...res.results];
          hasMore = !!res.next;
          page++;
        } else {
          hasMore = false;
        }
      }

      allData.sort((a, b) => {
        if (!a.registration_number) return 1;
        if (!b.registration_number) return -1;
        const regA = a.registration_number.toString();
        const regB = b.registration_number.toString();
        return sortOrder === "asc"
          ? regA.localeCompare(regB, undefined, { numeric: true })
          : regB.localeCompare(regA, undefined, { numeric: true });
      });

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Practice Test Report");
      const header = [
        "Test Name",
        "College ID",
        "Department",
        "Year",
        "Student Name",
        "Registration No",
        "Email",
        "Mobile",
        "User Name",
        "Capture Duration",
        "Average Mark",
        "Reassigned",
        "Attempt Count"
      ];
      worksheet.addRow(header);

      allData.forEach((item) => {
        worksheet.addRow([
          item.test_name,
          item.college_id,
          item.department_id,
          item.year || "",
          item.student_name,
          item.registration_number,
          item.email_id,
          item.mobile_number,
          item.user_name,
          item.capture_duration,
          item.avg_mark,
          item.is_reassigned ? "Yes" : "No",
          item.attempt_count
        ]);
      });

      worksheet.getRow(1).font = { bold: true };
      worksheet.columns.forEach((col) => {
        let maxLength = 0;
        col.eachCell({ includeEmpty: true }, (cell) => {
          maxLength = Math.max(maxLength, cell.value ? cell.value.toString().length : 0);
        });
        col.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "PracticeTestReport.xlsx";
      link.click();
    } catch (err) {
      console.error("Error exporting Excel:", err);
    }
  };

const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

// Sorting handler
useEffect(() => {
    fetchReportData();
  }, [currentPage, searchTerm, collegeId, department, year]);

  // Handlers
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const handleCollegeChange = (e) => setCollegeId(e.target.value);
  const handleDepartmentChange = (e) => setDepartment(e.target.value);
  const handleYearChange = (e) => setYear(e.target.value);
  const handleSortByRegNo = () => setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));

  const sortedData = [...data].sort((a, b) => {
    const regA = a.registration_number?.toString() || "";
    const regB = b.registration_number?.toString() || "";
    return sortOrder === "asc"
      ? regA.localeCompare(regB, undefined, { numeric: true })
      : regB.localeCompare(regA, undefined, { numeric: true });
  });
  return (
    <div className="placement-container" style={{maxWidth:"100%",marginTop:"-17px"}}>
      <h6>Students Practice Test Report</h6>

      {/* Filters */}
      <div className="row mb-3 align-items-center">
        <div className="col">

          <input
            type="text"
            placeholder="Search..."
            className="form-control" style={{background:"transparent",color:"white"}}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
       {userRole !== "Placement Officer" && (
  <div className="col">
     <select
              className="dropdown-custom college-name-dropdown"
              value={collegeId}
              onChange={handleCollegeChange}
            >
              <option value="">All Colleges</option>
              {collegeOptions.map((college) => (
                <option key={college.id} value={college.id}>
                  {college.name}
                </option>
              ))}
            </select>
  </div>
)}

       <div className="col">
          <select className="dropdown-custom college-name-dropdown" value={department} onChange={handleDepartmentChange}>
            <option value="">All Departments</option>
            {departmentOptions.map((dept, idx) => (
              <option key={idx} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>

        <div className="col">
          <select className="dropdown-custom" value={year} onChange={handleYearChange}>
            <option value="">All Years</option>
            {yearOptions.map((yr, idx) => (
              <option key={idx} value={yr}>
                {yr}
              </option>
            ))}
          </select>
        </div>
           <button onClick={exportToExcel} className="button-ques-save">Download </button>
        
      </div>
 <div className='table-responsive-results'>
          <table className="product-table" >
            <thead className="table-thead">
            <tr>
              <th style={{textAlign:"center"}}>Student Name</th>
              <th onClick={handleSortByRegNo} style={{cursor: "pointer",textAlign:"center"}}>
      Reg No {sortOrder === "asc" ? "▲" : "▼"}
    </th>
             <th style={{textAlign:"center"}}>TestName </th>
              <th style={{textAlign:"center"}}>Average</th>
              
              <th style={{textAlign:"center"}}>No of Attempt</th>
            </tr>
          </thead>
          <tbody>
           {sortedData.map((item, idx) => (
              <tr key={idx}>
                <td style={{textAlign:"center"}}>{item.student_name}</td>
                <td style={{textAlign:"center"}}>{item.registration_number}</td>
               
                <td style={{textAlign:"center"}}>{item.test_name}</td>
                <td style={{textAlign:"center"}}>{item.avg_mark}</td>
                
                <td style={{textAlign:"center"}}>{item.attempt_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
     
      
       <div className='dis-page' style={{ marginTop: '10%' }}>
                          {/* Custom Pagination */}
                          <CustomPagination
                              totalPages={totalPages}
                              currentPage={currentPage}
                             onPageChange={setCurrentPage}
                              maxVisiblePages={3} // Limit to 3 visible pages
                          />
                      </div>
    </div>
  );
};

export default PracticeTestReport;
